"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _R37KOEUWcjs = require('../__chunks/R37KOEUW.cjs');
require('../__chunks/75F3RDBE.cjs');
require('../__chunks/CVLMIMPT.cjs');
require('../__chunks/2RUCRSRF.cjs');


var _WMTGHDLEcjs = require('../__chunks/WMTGHDLE.cjs');


var _4TRESXTOcjs = require('../__chunks/4TRESXTO.cjs');

// src/tooltip/tooltip-store.ts
function createTooltipStore(props = {}) {
  var _a;
  if (process.env.NODE_ENV !== "production") {
    if (props.type === "label") {
      console.warn(
        "The `type` option on the tooltip store is deprecated.",
        "Render a visually hidden label or use the `aria-label` or `aria-labelledby` attributes on the anchor element instead.",
        "See https://ariakit.com/components/tooltip#tooltip-anchors-must-have-accessible-names"
      );
    }
  }
  const syncState = (_a = props.store) == null ? void 0 : _a.getState();
  const hovercard = _R37KOEUWcjs.createHovercardStore.call(void 0, {
    ...props,
    placement: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.placement,
      syncState == null ? void 0 : syncState.placement,
      "top"
    ),
    hideTimeout: _4TRESXTOcjs.defaultValue.call(void 0, props.hideTimeout, syncState == null ? void 0 : syncState.hideTimeout, 0)
  });
  const initialState = {
    ...hovercard.getState(),
    type: _4TRESXTOcjs.defaultValue.call(void 0, props.type, syncState == null ? void 0 : syncState.type, "description"),
    skipTimeout: _4TRESXTOcjs.defaultValue.call(void 0, props.skipTimeout, syncState == null ? void 0 : syncState.skipTimeout, 300)
  };
  const tooltip = _WMTGHDLEcjs.createStore.call(void 0, initialState, hovercard, props.store);
  return {
    ...hovercard,
    ...tooltip
  };
}


exports.createTooltipStore = createTooltipStore;
